import { AiOutlineLinkedin } from 'react-icons/ai'
import { FaRegCopyright, FaInstagram } from 'react-icons/fa'
import './index.css'

const FooterPage = () => (
  <footer className="footer">
   
    <div className="footer-top">
      <div className="footer-section">
        <h2>BE THE FIRST TO KNOW</h2>
        <p>Sign up for updates from Metta Muse</p>
        <div className="subscribe">
          <input type="email" placeholder="Enter your email" />
          <button className="button-sub">Subscribe</button>
        </div>
      </div>

      <div className="footer-section">
        <h2>Contact Us</h2>
        <p> +44 2211 335360</p>
        <p> customercare@mettamuse.com</p>
        <h3>CURRENCY</h3>
        <p>USD (Transactions will be completed in Euros)</p>
      </div>
    </div>

    <hr />

 
    <div className="footer-middle">
      <div className="footer-section">
        <h2>Metta Muse</h2>
        <p>About Us</p>
        <p>Stories</p>
        <p>Artisans</p>
        <p>Boutiques</p>
        <p>Contact Us</p>
        <p>EU Compliance</p>
      </div>

      <div className="footer-section">
        <h2>Quick Links</h2>
        <p>Orders & Shipping</p>
        <p>Payment & Pricing</p>
        <p>Returns & Refunds</p>
        <p>Terms & Conditions</p>
      </div>

      <div className="footer-section">
        <h2>Follow Us</h2>
        <div className="social-icons">
          <FaInstagram className="icon" />
          <AiOutlineLinkedin className="icon" />
        </div>

        <h3>Accepts</h3>
        <div className="payments">
          <img
            src="https://www.shutterstock.com/image-illustration/google-pay-logo-on-transparent-260nw-2311644375.jpg"
            alt="Google Pay"
          />
          <img
            src="https://www.shutterstock.com/image-vector/paypal-multinational-financial-technology-payment-260nw-2276341185.jpg"
            alt="PayPal"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/179/179431.png"
            alt="Visa"
          />
        </div>
      </div>
    </div>

    <p className="copyright">
      Copyright <FaRegCopyright /> 2023 Metta Muse. All rights reserved.
    </p>
  </footer>
)

export default FooterPage




 